import * as React from 'react';
import { observer } from 'mobx-react';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';

import ResidentCreateContainer from '~/containers/Residents/ResidentCreate';
import { Panel } from '@ixicare/ui';
import { ProfileTable } from '~components/Tables/ProfileTables/ProfileTable';
import { residentTableConfig } from '~components/Tables/ProfileTables/tableConfig';
import { ProfileType } from '@ixicare/resources';
import { useStores } from '~store/utils';

const ResidentsPage = observer(() => {
  const { permissions } = useStores();
  return (
    <>
      <Panel>
        <ProfileTable
          config={residentTableConfig}
          profileType={ProfileType.Resident}
          enableBatteryLegend={true}
          editPermissions={permissions.has('can_edit_all_profiles')}
          deletePermissions={permissions.has('can_delete_all_profiles')}
        />
      </Panel>
      {permissions.has('can_create_profiles') && <ResidentCreateContainer />}
    </>
  );
});

export default dashboardWrapper(ResidentsPage, t('menu.dashboard.residents'));
